import { LogLevel, OpenIdConfiguration } from 'angular-auth-oidc-client';

export const environment = {
    production: false,
    api: 'https://api.entrance-security.int.dvm.siemens.cloud',
    authentication: {
        unauthorizedRoute: 'auth/unauthorized',
        authority: 'https://idp.int.dvm.siemens.cloud/realms/dvm',
        authWellknownEndpointUrl: 'https://idp.int.dvm.siemens.cloud/realms/dvm/.well-known/openid-configuration',
        clientId: 'entrance-security-app',
        scope: 'openid profile dvm',
        logLevel: LogLevel.Error
    } satisfies OpenIdConfiguration
};
